import { confirmAsync } from '../../utils/confirm';
import { useState, useEffect, useCallback } from 'react';
import { apiRequest } from '../../services/api';
import { useKasa } from '../../context/KasaContext';
import { useAuth } from '../../context/AuthContext';
import DatePicker from '../../components/DatePicker';
import UsageInfo from '../../components/UsageInfo';
import { downloadExcel } from '../../utils/exportUtils';
import LoadingSpinner from '../../components/LoadingSpinner';

const inputClass = 'w-full border-2 border-gray-100 rounded-2xl px-5 py-3.5 text-xs font-bold text-gray-800 focus:outline-none focus:border-cyan-400 focus:ring-4 focus:ring-cyan-50 bg-white transition-all';
const labelClass = 'text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-2.5 ml-1 leading-none';

// ── İkonlar ──
const IkonHavuz   = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12h20M2 6c2 2 4 2 6 0s4-2 6 0 4 2 6 0M2 18c2 2 4 2 6 0s4-2 6 0 4 2 6 0"/></svg>;
const IkonPara    = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 6v12M8 10h6a2 2 0 010 4H8"/></svg>;
const IkonKisi    = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>;
const IkonBekle   = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>;
const IkonSil     = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/></svg>;
const IkonOde     = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2"/><path d="M1 10h22"/></svg>;

export default function HavuzYonetimi() {
  const { personel } = useAuth();
  const { odemeTipleri, bankalar, dovizKurlari, paraBirimleri, refreshGelir } = useKasa();

  const [gecisler, setGecisler]     = useState([]);
  const [yukleniyor, setYukleniyor] = useState(false);

  // Fiyat ayarları
  const [fiyatAyar, setFiyatAyar]         = useState({ yetiskinFiyat: 0, cocukFiyat: 0, yetiskinHaftasonu: 0, cocukHaftasonu: 0, yetiskinPzt:0,yetiskinSal:0,yetiskinCar:0,yetiskinPer:0,yetiskinCum:0,yetiskinCts:0,yetiskinPaz:0, cocukPzt:0,cocukSal:0,cocukCar:0,cocukPer:0,cocukCum:0,cocukCts:0,cocukPaz:0, cocukUcretsizYas: 0, aktifMi: true });
  const [fiyatYukleniyor, setFiyatYukleniyor] = useState(false);
  const [fiyatKaydediliyor, setFiyatKaydediliyor] = useState(false);
  const [fiyatPanelAcik, setFiyatPanelAcik] = useState(false);

  // Tekli / Grup tab
  const [aktifTab, setAktifTab] = useState('tekli'); // 'tekli' | 'grup'

  // Giriş formu
  const ilkForm = { misafirAdi: '', misafirTipi: 'yetiskin', yas: '', tutar: '', odemeTipi: '', paraBirimi: 'TL', bankaAdi: '', odendi: true, notlar: '' };
  const [form, setForm]             = useState(ilkForm);
  const [kaydediliyor, setKaydediliyor] = useState(false);

  // Grup formu
  const ilkGrupForm = { grupAdi: '', odemeTipi: '', paraBirimi: 'TL', bankaAdi: '', odendi: true, notlar: '' };
  const ilkKisi = () => ({ misafirAdi: '', misafirTipi: 'yetiskin', yas: '', tutar: '' });
  const [grupForm, setGrupForm]     = useState(ilkGrupForm);
  const [grupKisiler, setGrupKisiler] = useState([ilkKisi()]);
  const [grupKaydediliyor, setGrupKaydediliyor] = useState(false);

  // Grup ödeme modalı
  const [grupOdeModal, setGrupOdeModal] = useState(null); // { grupAdi, toplamTutar, odenenTutar }
  const [grupOdeForm, setGrupOdeForm]   = useState({ odemeTipi: '', paraBirimi: 'TL', bankaAdi: '', tutar: '' });
  const [grupOdeYukleniyor, setGrupOdeYukleniyor] = useState(false);

  // Ödeme modalı
  const [odeModal, setOdeModal]     = useState(null); // { id, misafirAdi, tutar, odenenTutar }
  const [odeForm, setOdeForm]       = useState({ odemeTipi: '', paraBirimi: 'TL', bankaAdi: '', tutar: '' });
  const [odeYukleniyor, setOdeYukleniyor] = useState(false);

  // Filtreler
  const [filtreTarih, setFiltreTarih] = useState('');
  const [filtreTip, setFiltreTip]     = useState('hepsi');
  const [filtreOdeme, setFiltreOdeme] = useState('hepsi');

  // Varsayılan ödeme tipi ayarla
  useEffect(() => {
    if (odemeTipleri.length > 0) {
      const nakit = odemeTipleri.find(o => o.ad?.toLowerCase().includes('nakit'));
      const ilk = (nakit || odemeTipleri[0]).ad;
      setForm(p => ({ ...p, odemeTipi: p.odemeTipi || ilk }));
      setOdeForm(p => ({ ...p, odemeTipi: p.odemeTipi || ilk }));
      setGrupForm(p => ({ ...p, odemeTipi: p.odemeTipi || ilk }));
      setGrupOdeForm(p => ({ ...p, odemeTipi: p.odemeTipi || ilk }));
    }
  }, [odemeTipleri]);

  const yukle = useCallback(async () => {
    setYukleniyor(true);
    try { setGecisler((await apiRequest('havuz/gecisler')) || []); }
    catch { /* sessiz */ }
    setYukleniyor(false);
  }, []);

  useEffect(() => {
    yukle();
    setFiyatYukleniyor(true);
    apiRequest('havuz/fiyat')
      .then(d => {
        if (d) {
          setFiyatAyar(d);
          if (d.aktifMi) {
            // Mevcut günün fiyatını hesapla
            const gunIdx = (new Date().getDay() === 0 ? 6 : new Date().getDay() - 1);
            const gunKey = ['pzt','sal','car','per','cum','cts','paz'][gunIdx];
            const yFiyat = String(d[`yetiskin${gunKey.charAt(0).toUpperCase()+gunKey.slice(1)}`] || 0);
            setForm(p => ({ ...p, tutar: yFiyat }));
            setGrupKisiler([{ ...ilkKisi(), tutar: yFiyat }]);
          }
        }
      })
      .catch(() => {})
      .finally(() => setFiyatYukleniyor(false));
  }, [yukle]);

  // ── Yardımcılar ──
  function isNakitTipi(tip) {
    return !tip || tip.toLowerCase().includes('nakit');
  }

  const GUN_KEYS = ['pzt','sal','car','per','cum','cts','paz'];
  const GUN_LABELS = ['Pazartesi','Salı','Çarşamba','Perşembe','Cuma','Cumartesi','Pazar'];
  const GUN_KISA = ['Pzt','Sal','Çar','Per','Cum','Cts','Paz'];

  function getGunIndex() {
    // JS: 0=Pazar, 1=Pazartesi ... 6=Cumartesi
    const jsDay = new Date().getDay();
    return jsDay === 0 ? 6 : jsDay - 1; // 0=Pzt ... 6=Paz
  }

  function hesaplaFiyat(tip, yas) {
    if (!fiyatAyar.aktifMi) return '';
    const gunIdx = getGunIndex();
    const gunKey = GUN_KEYS[gunIdx];

    if (tip === 'cocuk') {
      const y = parseInt(yas) || 0;
      if (fiyatAyar.cocukUcretsizYas > 0 && y <= fiyatAyar.cocukUcretsizYas) return '0';
      const gunFiyat = fiyatAyar[`cocuk${gunKey.charAt(0).toUpperCase()+gunKey.slice(1)}`];
      return String(gunFiyat || 0);
    }
    const gunFiyat = fiyatAyar[`yetiskin${gunKey.charAt(0).toUpperCase()+gunKey.slice(1)}`];
    return String(gunFiyat || 0);
  }

  function tlKarsiligi(tutar, para) {
    if (!tutar || para === 'TL' || para === 'TRY') return null;
    const kur = dovizKurlari[para];
    if (!kur) return null;
    return parseFloat(tutar) * kur;
  }

  // ── Giriş formu değişiklikleri ──
  function handleTipChange(tip) {
    setForm(p => ({ ...p, misafirTipi: tip, tutar: hesaplaFiyat(tip, p.yas) }));
  }
  function handleYasChange(yas) {
    setForm(p => ({ ...p, yas, tutar: p.misafirTipi === 'cocuk' ? hesaplaFiyat('cocuk', yas) : p.tutar }));
  }

  // ── Giriş kaydet ──
  async function handleEkle() {
    if (!form.misafirAdi.trim()) { alert('Misafir adı zorunludur.'); return; }
    if (parseFloat(form.tutar) < 0) { alert('Tutar 0 veya daha büyük olmalıdır.'); return; }
    setKaydediliyor(true);
    try {
      const kur = dovizKurlari[form.paraBirimi] || 1;
      const tlTutar = form.paraBirimi === 'TL' ? parseFloat(form.tutar) || 0 : (parseFloat(form.tutar) || 0) * kur;
      await apiRequest('havuz/gecisler', 'POST', {
        misafirAdi:  form.misafirAdi.trim(),
        misafirTipi: form.misafirTipi,
        yas:         form.yas ? parseInt(form.yas) : null,
        tutar:       tlTutar,
        odemeTipi:   form.odemeTipi,
        odendi:      form.odendi,
        notlar:      form.notlar.trim() || null,
      });
      setForm(ilkForm);
      if (odemeTipleri.length > 0) {
        const nakit = odemeTipleri.find(o => o.ad?.toLowerCase().includes('nakit'));
        setForm(p => ({ ...p, odemeTipi: (nakit || odemeTipleri[0]).ad }));
      }
      yukle();
      if (form.odendi) refreshGelir?.();
    } catch (e) {
      alert(e.message || 'Hata oluştu.');
    }
    setKaydediliyor(false);
  }

  // ── Ödeme al ──
  function handleOdeAc(g) {
    setOdeModal({ id: g.havuzGecisId, misafirAdi: g.misafirAdi, tutar: g.tutar, odenenTutar: g.odenenTutar || 0 });
    setOdeForm(p => ({ ...p, tutar: (g.tutar - (g.odenenTutar || 0)).toFixed(2) }));
  }

  async function handleOde() {
    if (!odeForm.odemeTipi) { alert('Ödeme tipi seçiniz.'); return; }
    const tutar = parseFloat(odeForm.tutar);
    if (!tutar || tutar <= 0) { alert('Geçerli bir tutar giriniz.'); return; }
    setOdeYukleniyor(true);
    try {
      const kur = dovizKurlari[odeForm.paraBirimi] || 1;
      await apiRequest(`havuz/gecisler/${odeModal.id}/ode`, 'POST', {
        tutar,
        odemeTipi: odeForm.odemeTipi,
        paraBirimi: odeForm.paraBirimi,
        kurDegeri: kur,
        bankaAdi: !isNakitTipi(odeForm.odemeTipi) ? odeForm.bankaAdi : '',
        personelId: personel?.personelId,
      });
      setOdeModal(null);
      yukle();
      refreshGelir?.();
    } catch (e) {
      alert(e.message || 'Ödeme başarısız.');
    }
    setOdeYukleniyor(false);
  }

  // ── Grup kişi yönetimi ──
  function grupKisiGuncelle(i, field, value) {
    setGrupKisiler(prev => prev.map((k, idx) => {
      if (idx !== i) return k;
      const updated = { ...k, [field]: value };
      if (field === 'misafirTipi') updated.tutar = hesaplaFiyat(value, updated.yas);
      if (field === 'yas' && k.misafirTipi === 'cocuk') updated.tutar = hesaplaFiyat('cocuk', value);
      return updated;
    }));
  }
  function grupKisiEkle() { setGrupKisiler(p => [...p, { ...ilkKisi(), tutar: hesaplaFiyat('yetiskin', '') }]); }
  function grupKisiSil(i) { setGrupKisiler(p => p.filter((_, idx) => idx !== i)); }

  const grupToplamTutar = grupKisiler.reduce((s, k) => {
    const kur = dovizKurlari[grupForm.paraBirimi] || 1;
    const tl = grupForm.paraBirimi === 'TL' ? parseFloat(k.tutar) || 0 : (parseFloat(k.tutar) || 0) * kur;
    return s + tl;
  }, 0);

  // ── Grup kaydet ──
  async function handleGrupEkle() {
    if (!grupForm.grupAdi.trim()) { alert('Grup adı zorunludur.'); return; }
    if (grupKisiler.length === 0) { alert('En az bir kişi ekleyin.'); return; }
    if (grupKisiler.some(k => !k.misafirAdi.trim())) { alert('Tüm kişilerin adı zorunludur.'); return; }
    setGrupKaydediliyor(true);
    try {
      const kur = dovizKurlari[grupForm.paraBirimi] || 1;
      await apiRequest('havuz/gecisler/grup', 'POST', {
        grupAdi:   grupForm.grupAdi.trim(),
        odemeTipi: grupForm.odemeTipi,
        odendi:    grupForm.odendi,
        notlar:    grupForm.notlar.trim() || null,
        kisiler:   grupKisiler.map(k => ({
          misafirAdi:  k.misafirAdi.trim(),
          misafirTipi: k.misafirTipi,
          yas:         k.yas ? parseInt(k.yas) : null,
          tutar:       grupForm.paraBirimi === 'TL' ? parseFloat(k.tutar) || 0 : (parseFloat(k.tutar) || 0) * kur,
        })),
      });
      setGrupForm(ilkGrupForm);
      setGrupKisiler([ilkKisi()]);
      if (odemeTipleri.length > 0) {
        const nakit = odemeTipleri.find(o => o.ad?.toLowerCase().includes('nakit'));
        setGrupForm(p => ({ ...p, odemeTipi: (nakit || odemeTipleri[0]).ad }));
      }
      yukle();
      if (grupForm.odendi) refreshGelir?.();
    } catch (e) {
      alert(e.message || 'Hata oluştu.');
    }
    setGrupKaydediliyor(false);
  }

  // ── Grup ödeme ──
  function handleGrupOdeAc(grupAdi) {
    const grupdakiler = gecisler.filter(g => g.grupAdi === grupAdi);
    const toplamTutar = grupdakiler.reduce((s, g) => s + g.tutar, 0);
    const odenenTutar = grupdakiler.reduce((s, g) => s + (g.odenenTutar || 0), 0);
    setGrupOdeModal({ grupAdi, toplamTutar, odenenTutar });
    setGrupOdeForm(p => ({ ...p, tutar: (toplamTutar - odenenTutar).toFixed(2) }));
  }

  async function handleGrupOde() {
    if (!grupOdeForm.odemeTipi) { alert('Ödeme tipi seçiniz.'); return; }
    const tutar = parseFloat(grupOdeForm.tutar);
    if (!tutar || tutar <= 0) { alert('Geçerli bir tutar giriniz.'); return; }
    setGrupOdeYukleniyor(true);
    try {
      const kur = dovizKurlari[grupOdeForm.paraBirimi] || 1;
      await apiRequest(`havuz/gecisler/grup/${encodeURIComponent(grupOdeModal.grupAdi)}/ode`, 'POST', {
        tutar,
        odemeTipi:  grupOdeForm.odemeTipi,
        paraBirimi: grupOdeForm.paraBirimi,
        kurDegeri:  kur,
        bankaAdi:   !isNakitTipi(grupOdeForm.odemeTipi) ? grupOdeForm.bankaAdi : '',
        personelId: personel?.personelId,
      });
      setGrupOdeModal(null);
      yukle();
      refreshGelir?.();
    } catch (e) {
      alert(e.message || 'Ödeme başarısız.');
    }
    setGrupOdeYukleniyor(false);
  }

  // ── Sil ──
  async function handleSil(id, ad) {
    if (!(await confirmAsync())) return;
    try {
      await apiRequest(`havuz/gecisler/${id}`, 'DELETE');
      setGecisler(g => g.filter(x => x.havuzGecisId !== id));
    } catch { alert('Silinemedi.'); }
  }

  // ── Fiyat kaydet ──
  async function handleFiyatKaydet(e) {
    e.preventDefault();
    setFiyatKaydediliyor(true);
    try {
      await apiRequest('havuz/fiyat', 'POST', fiyatAyar);
      setFiyatPanelAcik(false);
    } catch { alert('Kaydedilemedi.'); }
    setFiyatKaydediliyor(false);
  }

  // ── Grup özeti (bekleyen gruplar için Öde butonu) ──
  const grupOzeti = gecisler.reduce((acc, g) => {
    if (!g.grupAdi) return acc;
    if (!acc[g.grupAdi]) acc[g.grupAdi] = { toplamTutar: 0, odenenTutar: 0, hepsiBitti: true };
    acc[g.grupAdi].toplamTutar += g.tutar;
    acc[g.grupAdi].odenenTutar += g.odenenTutar || 0;
    if (!g.odendi) acc[g.grupAdi].hepsiBitti = false;
    return acc;
  }, {});

  // ── Filtreleme ──
  const filtered = gecisler.filter(g => {
    if (filtreTarih) {
      // filtreTarih dd.MM.yyyy formatında
      if (!g.girisTarihi?.startsWith(filtreTarih)) return false;
    }
    if (filtreTip !== 'hepsi' && g.misafirTipi !== filtreTip) return false;
    if (filtreOdeme === 'odendi'   && !g.odendi) return false;
    if (filtreOdeme === 'bekliyor' &&  g.odendi) return false;
    return true;
  });

  // ── İstatistikler ──
  const bugun = new Date().toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '.');
  const bugunGecisler   = gecisler.filter(g => g.girisTarihi?.startsWith(bugun));
  const bugunTahsilat   = bugunGecisler.filter(g => g.odendi).reduce((s, g) => s + g.tutar, 0);
  const bekleyenTutar   = gecisler.filter(g => !g.odendi).reduce((s, g) => s + (g.tutar - (g.odenenTutar || 0)), 0);
  const toplamKisi      = filtered.length;

  return (
    <div className="min-h-screen bg-[#f8fafc] pb-20">

      {/* ── Header ── */}
      <div className="bg-[#0f172a] pt-12 pb-24 px-4 sm:px-8 relative overflow-hidden shadow-[0_20px_50px_rgba(15,23,42,0.3)]">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-cyan-500/10 rounded-full -translate-y-1/2 translate-x-1/3 blur-[100px] pointer-events-none" />
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-blue-500/10 rounded-full translate-y-1/2 -translate-x-1/2 blur-[80px] pointer-events-none" />

        <div className="max-w-[1600px] mx-auto flex flex-col md:flex-row md:items-center justify-between gap-8 relative z-10">
          <div>
            <div className="flex items-center gap-3 mb-4 opacity-50">
              <span className="text-white text-[10px] font-black tracking-[0.3em] uppercase">Havuz Kompleksi</span>
              <span className="text-white/20">/</span>
              <span className="text-white text-[10px] font-black tracking-[0.3em] uppercase">Giriş Yönetimi</span>
            </div>
            <div className="flex items-center gap-6">
              <div className="w-20 h-20 bg-white/5 backdrop-blur-2xl rounded-[2.5rem] border border-white/10 flex items-center justify-center text-4xl shadow-2xl relative group overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                <span className="relative z-10">🏊</span>
              </div>
              <div>
                <h1 className="text-5xl font-black text-white tracking-tighter leading-tight drop-shadow-2xl">Havuz Yönetimi</h1>
                <p className="text-cyan-400 text-[10px] font-black uppercase tracking-widest mt-3 leading-none flex items-center gap-2">
                  <span className="w-2 h-2 bg-cyan-400 rounded-full animate-pulse blur-[1px]" />
                  Dış misafir giriş ve tahsilat takibi
                </p>
              </div>
            </div>
          </div>
          
          <div className="flex items-center gap-3">
            <button
              onClick={() => downloadExcel('havuz-gecisleri', 'Havuz Girişleri',
                ['Misafir', 'Tür', 'Grup', 'Giriş Tarihi', 'Tutar (₺)', 'Durum'],
                filtered.map(g => [
                  g.misafirAdi, g.misafirTipi === 'cocuk' ? 'Çocuk' : 'Yetişkin',
                  g.grupAdi || '—', g.girisTarihi || '—',
                  (g.tutar || 0).toFixed(2),
                  g.odendi ? 'Ödendi' : 'Bekliyor'
                ])
              )}
              className="h-14 px-6 bg-emerald-500/20 hover:bg-emerald-500/30 text-emerald-300 border border-emerald-500/20 rounded-[2rem] font-black text-[10px] uppercase tracking-[0.2em] transition-all shadow-xl hover:-translate-y-1 flex items-center gap-3 backdrop-blur-md"
            >
              <span className="text-xl">📊</span> Excel
            </button>
            <button
              onClick={() => setFiyatPanelAcik(p => !p)}
              className="h-14 px-8 bg-white/5 hover:bg-white/10 text-white border border-white/10 rounded-[2rem] font-black text-[10px] uppercase tracking-[0.2em] transition-all shadow-xl hover:-translate-y-1 flex items-center gap-3 backdrop-blur-md"
            >
              <span className="text-xl">⚙️</span> Fiyat Ayarları
            </button>
          </div>
        </div>
      </div>

      <div className="max-w-[1600px] mx-auto px-4 sm:px-8 -mt-10 relative z-20">

      {/* ── Fiyat Ayarları paneli (collapse) ── */}
      {fiyatPanelAcik && (
        <form onSubmit={handleFiyatKaydet} className="bg-white rounded-[2rem] border border-gray-100 shadow-2xl p-8 mb-8 relative overflow-hidden animate-fadeIn">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-cyan-400 to-blue-500" />
          <div className="flex flex-wrap items-center gap-4 mb-8">
            <h2 className="font-black text-xl text-gray-800 flex items-center gap-3 tracking-tight flex-1 min-w-0">
              <span className="w-10 h-10 bg-cyan-50 text-cyan-500 rounded-2xl flex items-center justify-center text-lg shadow-sm border border-cyan-100 flex-shrink-0">⚙️</span>
              Fiyat Politikası
            </h2>
            <label className="flex items-center gap-3 text-[11px] font-black text-gray-500 cursor-pointer uppercase tracking-widest bg-gray-50 px-4 py-2 rounded-xl border border-gray-200 hover:bg-gray-100 transition-colors whitespace-nowrap flex-shrink-0">
              <input type="checkbox" checked={fiyatAyar.aktifMi} onChange={e => setFiyatAyar(p => ({ ...p, aktifMi: e.target.checked }))} className="w-4 h-4 rounded text-cyan-500 focus:ring-cyan-500 border-gray-300" />
              Otomatik Fiyatlandırma
            </label>
          </div>
          {fiyatYukleniyor ? (
            <div className="flex justify-center items-center py-8 opacity-50">
               <span className="w-6 h-6 border-4 border-cyan-500 border-t-transparent rounded-full animate-spin"/>
            </div>
          ) : (
            <>
              {/* Gün bazlı fiyat tablosu */}
              <div className="overflow-x-auto">
                <table className="w-full text-center border-separate" style={{borderSpacing:'0 6px'}}>
                  <thead>
                    <tr>
                      <th className="text-left text-[9px] font-black text-gray-400 uppercase tracking-widest px-3 py-2 w-28">Tip</th>
                      {GUN_KISA.map((g,i) => (
                        <th key={g} className={`text-[9px] font-black uppercase tracking-widest px-2 py-2 ${i === getGunIndex() ? 'text-cyan-600' : 'text-gray-400'}`}>{g}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="bg-blue-50/50 rounded-2xl">
                      <td className="text-left text-[10px] font-black text-blue-600 uppercase tracking-widest px-3 py-3 rounded-l-2xl">🧑 Yetişkin</td>
                      {GUN_KEYS.map((g,i) => {
                        const key = `yetiskin${g.charAt(0).toUpperCase()+g.slice(1)}`;
                        return (
                          <td key={g} className={`px-1 py-2 ${i === getGunIndex() ? 'bg-cyan-100/60 rounded-xl' : ''}`}>
                            <input type="number" min="0" step="0.01" value={fiyatAyar[key]} onChange={e => setFiyatAyar(p => ({ ...p, [key]: parseFloat(e.target.value) || 0 }))}
                              className="w-full text-center bg-white border-2 border-gray-100 focus:border-cyan-400 rounded-xl px-2 py-2.5 text-xs font-black text-gray-700 outline-none transition-colors" />
                          </td>
                        );
                      })}
                    </tr>
                    <tr className="bg-pink-50/50 rounded-2xl">
                      <td className="text-left text-[10px] font-black text-pink-600 uppercase tracking-widest px-3 py-3 rounded-l-2xl">👶 Çocuk</td>
                      {GUN_KEYS.map((g,i) => {
                        const key = `cocuk${g.charAt(0).toUpperCase()+g.slice(1)}`;
                        return (
                          <td key={g} className={`px-1 py-2 ${i === getGunIndex() ? 'bg-cyan-100/60 rounded-xl' : ''}`}>
                            <input type="number" min="0" step="0.01" value={fiyatAyar[key]} onChange={e => setFiyatAyar(p => ({ ...p, [key]: parseFloat(e.target.value) || 0 }))}
                              className="w-full text-center bg-white border-2 border-gray-100 focus:border-pink-400 rounded-xl px-2 py-2.5 text-xs font-black text-gray-700 outline-none transition-colors" />
                          </td>
                        );
                      })}
                    </tr>
                  </tbody>
                </table>
                <p className="text-[9px] font-bold text-gray-400 mt-2 text-center">Bugün: <span className="text-cyan-500 font-black">{GUN_LABELS[getGunIndex()]}</span></p>
              </div>

              {/* Ücretsiz yaş */}
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-6">
                <div>
                  <label className={labelClass}>Ücretsiz Yaş Altı Sınırı</label>
                  <div className="relative">
                    <input className={inputClass} type="number" min="0" max="18" value={fiyatAyar.cocukUcretsizYas} onChange={e => setFiyatAyar(p => ({ ...p, cocukUcretsizYas: parseInt(e.target.value) || 0 }))} placeholder="0 = devre dışı" />
                    <span className="absolute right-4 top-1/2 -translate-y-1/2 text-[10px] font-black text-gray-400">YAŞ</span>
                  </div>
                </div>
              </div>
            </>
          )}
          <div className="flex justify-end mt-8 gap-3">
            <button type="button" onClick={() => setFiyatPanelAcik(false)} className="px-6 py-3 text-[11px] font-black border-2 border-gray-100 rounded-2xl text-gray-500 hover:bg-gray-50 transition-all uppercase tracking-widest">İptal</button>
            <button type="submit" disabled={fiyatKaydediliyor} className="px-8 py-3 text-[11px] bg-gradient-to-r from-cyan-500 to-blue-600 hover:opacity-90 text-white rounded-2xl font-black uppercase tracking-widest disabled:opacity-60 transition-all shadow-lg hover:-translate-y-0.5">
              {fiyatKaydediliyor ? 'Kaydediliyor...' : '⚙ GÜNCELLE'}
            </button>
          </div>
        </form>
      )}

        {/* Stat kartları */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          {[
            { label: "Bugün Tahsilat", value: `${bugunTahsilat.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺`, icon: '💰', color: 'text-emerald-600', bg: 'bg-emerald-50 border-emerald-100/50' },
            { label: "Bugün Giriş",    value: bugunGecisler.length, icon: '🎫', color: 'text-cyan-600', bg: 'bg-cyan-50 border-cyan-100/50' },
            { label: "Toplam Kayıt",   value: gecisler.length, icon: '👥', color: 'text-indigo-600', bg: 'bg-indigo-50 border-indigo-100/50' },
            { label: "Bekleyen Tahsilat", value: bekleyenTutar > 0 ? `${bekleyenTutar.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺` : '—', icon: '⏳', color: 'text-rose-600', bg: 'bg-rose-50 border-rose-100/50', pulse: bekleyenTutar > 0 },
          ].map((s, i) => (
            <div key={i} className={`rounded-[2rem] p-6 border transition-all hover:translate-y-[-4px] hover:shadow-2xl relative overflow-hidden group shadow-xl ${s.bg}`}>
              <div className="absolute top-0 right-0 p-5 text-4xl opacity-[0.05] transition-all group-hover:scale-125 group-hover:-rotate-12">{s.icon}</div>
              <div className="flex items-center gap-2 mb-3">
                <span className="text-[10px] font-black text-gray-500 uppercase tracking-widest">{s.label}</span>
                {s.pulse && <span className="w-2 h-2 bg-rose-500 rounded-full animate-pulse shadow-[0_0_8px_rgba(225,29,72,0.8)]" />}
              </div>
              <h3 className={`text-2xl font-black tracking-tighter ${s.color}`}>
                {s.value}
              </h3>
            </div>
          ))}
        </div>

      {/* ── Ana içerik ── */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

                {/* ── Sol: Yeni Giriş Formu ── */}
        <div className="bg-white rounded-[2rem] border border-gray-100 shadow-xl p-8 space-y-6 relative overflow-hidden h-fit animate-slideInLeft">
          <div className="absolute top-0 right-0 w-32 h-32 bg-cyan-50 rounded-bl-full flex items-center justify-center -z-0">
             <span className="text-4xl opacity-20 -mt-8 -mr-8">📝</span>
          </div>

          <div className="relative z-10">
            {/* Tab seçici */}
            <div className="flex bg-gray-50/80 p-1.5 rounded-2xl border border-gray-100 mb-6">
              {[['tekli','👤 Tekli Giriş'],['grup','👥 Grup Girişi']].map(([k,l]) => (
                <button key={k} onClick={() => setAktifTab(k)}
                  className={`flex-1 py-3 text-[11px] font-black uppercase tracking-widest transition-all rounded-xl ${aktifTab === k ? 'bg-white text-cyan-600 shadow-sm border border-gray-200/60' : 'text-gray-400 hover:text-gray-600 hover:bg-gray-100/50'}`}>
                  {l}
                </button>
              ))}
            </div>

            {aktifTab === 'tekli' && (<div className="space-y-6 animate-fadeIn">
            <div>
              <label className={labelClass}>Misafir Adı *</label>
              <input className={inputClass} value={form.misafirAdi} onChange={e => setForm(p => ({ ...p, misafirAdi: e.target.value }))} placeholder="Örn: Ahmet Yılmaz" />
            </div>

            <div className="grid grid-cols-2 gap-5">
              <div>
                <label className={labelClass}>Misafir Tipi</label>
                <div className="flex bg-gray-50/80 p-1 rounded-xl border border-gray-100 h-[calc(100%-1.25rem)] items-center">
                  {['yetiskin', 'cocuk'].map(tip => (
                    <button key={tip} type="button"
                      onClick={() => handleTipChange(tip)}
                      className={`flex-1 py-2.5 text-[10px] font-black uppercase tracking-widest transition-all rounded-lg ${form.misafirTipi === tip ? 'bg-white text-cyan-600 shadow-sm border border-gray-200/50' : 'text-gray-400 hover:text-gray-600 hover:bg-gray-100'}`}>
                      {tip === 'yetiskin' ? 'Yetişkin' : 'Çocuk'}
                    </button>
                  ))}
                </div>
              </div>
              {form.misafirTipi === 'cocuk' && (
                <div className="animate-scaleIn origin-left">
                  <label className={labelClass}>Yaş</label>
                  <input className={inputClass} type="number" min="0" max="17" value={form.yas} onChange={e => handleYasChange(e.target.value)} placeholder="0–17" />
                </div>
              )}
            </div>

            <div className="grid grid-cols-2 gap-5">
              <div>
                <label className={labelClass}>Tutar</label>
                <input className={inputClass} type="number" min="0" step="0.01" value={form.tutar} onChange={e => setForm(p => ({ ...p, tutar: e.target.value }))} placeholder="0.00" />
              </div>
              <div>
                <label className={labelClass}>Para Birimi</label>
                <select className={inputClass} value={form.paraBirimi} onChange={e => setForm(p => ({ ...p, paraBirimi: e.target.value }))}>
                  <option value="TL">TL</option>
                  {(paraBirimleri || []).filter(p => p.tcmbKod !== 'TL' && p.tcmbKod !== 'TRY').map(p => (
                    <option key={p.tcmbKod} value={p.tcmbKod}>{p.tcmbKod}</option>
                  ))}
                </select>
              </div>
            </div>
            {tlKarsiligi(form.tutar, form.paraBirimi) !== null && (
              <p className="text-[10px] font-black text-cyan-600 bg-cyan-50 px-3 py-2 rounded-xl -mt-2 inline-flex items-center gap-1.5 uppercase tracking-widest animate-fadeIn">
                <span className="opacity-70">KARŞILIĞI:</span> {tlKarsiligi(form.tutar, form.paraBirimi).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
              </p>
            )}

            <div>
              <label className={labelClass}>Ödeme Tipi</label>
              <select className={inputClass} value={form.odemeTipi} onChange={e => setForm(p => ({ ...p, odemeTipi: e.target.value }))}>
                {odemeTipleri.map(o => <option key={o.ad} value={o.ad}>{o.ad}</option>)}
              </select>
            </div>

            {!isNakitTipi(form.odemeTipi) && bankalar.length > 0 && (
              <div className="animate-scaleIn origin-top">
                <label className={labelClass}>Banka</label>
                <select className={inputClass} value={form.bankaAdi} onChange={e => setForm(p => ({ ...p, bankaAdi: e.target.value }))}>
                  <option value="">Seçiniz</option>
                  {bankalar.map(b => <option key={b.ad} value={b.ad}>{b.ad}</option>)}
                </select>
              </div>
            )}

            <div>
              <label className={labelClass}>Not</label>
              <input className={inputClass} value={form.notlar} onChange={e => setForm(p => ({ ...p, notlar: e.target.value }))} placeholder="İsteğe bağlı not ekleyebilirsiniz..." />
            </div>

            <label className="flex items-center gap-3 p-4 rounded-xl border border-gray-100 bg-gray-50/50 cursor-pointer group transition-colors hover:bg-gray-50">
              <input type="checkbox" checked={form.odendi} onChange={e => setForm(p => ({ ...p, odendi: e.target.checked }))} className="w-5 h-5 rounded text-cyan-500 focus:ring-cyan-500 border-gray-300 transition-transform group-hover:scale-110" />
              <span className="text-[11px] font-black text-gray-600">Ödeme anında tahsil edildi (Kasaya yansıt)</span>
            </label>

            <button onClick={handleEkle} disabled={kaydediliyor}
              className="w-full bg-gradient-to-r from-cyan-500 to-blue-600 hover:opacity-90 text-white rounded-2xl py-4 pt-4.5 text-[11px] font-black uppercase tracking-[0.2em] shadow-[0_10px_20px_-10px_rgba(6,182,212,0.5)] transition-all hover:-translate-y-1 disabled:opacity-50 mt-4">
              {kaydediliyor ? 'KAYDEDİLİYOR...' : '🎫 GİRİŞ OLUŞTUR'}
            </button>
            </div>)}

            {/* ── Grup Girişi ── */}
            {aktifTab === 'grup' && (<div className="space-y-6 animate-fadeIn">
            <div>
              <label className={labelClass}>Grup/Şirket Adı *</label>
              <input className={inputClass} value={grupForm.grupAdi} onChange={e => setGrupForm(p => ({ ...p, grupAdi: e.target.value }))} placeholder="Örn: Yılmaz Ailesi, ABC Corp..." />
            </div>

            {/* Kişi listesi */}
            <div className="space-y-4">
              <div className="flex items-center justify-between pb-2 border-b border-gray-100">
                <label className={`${labelClass} !mb-0`}>Kişiler ({grupKisiler.length}) *</label>
                <button onClick={grupKisiEkle} className="text-[10px] font-black text-cyan-600 hover:text-cyan-800 uppercase tracking-widest bg-cyan-50 px-3 py-1.5 rounded-lg transition-colors flex items-center gap-1 group">
                  <span className="text-base leading-none mb-0.5 group-hover:rotate-90 transition-transform">+</span> Yeni Ekle
                </button>
              </div>
              
              <div className="space-y-3 max-h-[40vh] overflow-y-auto pr-2 custom-scrollbar">
                {grupKisiler.map((k, i) => (
                  <div key={i} className="bg-gray-50/80 rounded-2xl p-4 space-y-4 border border-gray-100 hover:border-indigo-100 transition-colors group animate-scaleIn">
                    <div className="flex items-center justify-between">
                      <span className="text-[10px] font-black text-gray-400 bg-white px-2 py-1 rounded-md border border-gray-100 shadow-sm">#{i + 1}</span>
                      {grupKisiler.length > 1 && (
                        <button onClick={() => grupKisiSil(i)} className="text-red-400 hover:text-white hover:bg-red-500 w-6 h-6 flex items-center justify-center rounded-full transition-colors font-bold text-xs uppercase cursor-pointer">✕</button>
                      )}
                    </div>
                    <div>
                        <input className={inputClass} value={k.misafirAdi} onChange={e => grupKisiGuncelle(i, 'misafirAdi', e.target.value)} placeholder="Misafir Ad Soyad *" />
                    </div>
                    <div className="grid grid-cols-2 gap-3">
                      <div className="flex bg-white p-1 rounded-xl border border-gray-100">
                        {['yetiskin', 'cocuk'].map(tip => (
                          <button key={tip} type="button" onClick={() => grupKisiGuncelle(i, 'misafirTipi', tip)}
                            className={`flex-1 py-2 text-[10px] font-black uppercase tracking-widest transition-all rounded-lg ${k.misafirTipi === tip ? 'bg-indigo-50 text-indigo-600 shadow-sm' : 'text-gray-400 hover:text-gray-600 hover:bg-gray-50'}`}>
                            {tip === 'yetiskin' ? 'Yetişkin' : 'Çocuk'}
                          </button>
                        ))}
                      </div>
                      {k.misafirTipi === 'cocuk' ? (
                        <input className={inputClass} type="number" min="0" max="17" value={k.yas} onChange={e => grupKisiGuncelle(i, 'yas', e.target.value)} placeholder="Yaş Giriniz" />
                      ) : <div />}
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="relative flex-1">
                        <input className={inputClass} type="number" min="0" step="0.01" value={k.tutar} onChange={e => grupKisiGuncelle(i, 'tutar', e.target.value)} placeholder="Tutar" />
                        <span className="absolute right-4 top-1/2 -translate-y-1/2 text-[10px] font-black text-gray-400">{grupForm.paraBirimi}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Grup toplam */}
            <div className="bg-gradient-to-r from-indigo-50 to-blue-50 rounded-2xl px-6 py-5 flex items-center justify-between border border-blue-100 shadow-inner">
              <div className="flex flex-col">
                 <span className="text-[10px] font-black text-indigo-600 uppercase tracking-widest">GRUP TOPLAMI</span>
                 <span className="text-[9px] font-bold text-indigo-400 uppercase tracking-widest mt-0.5">{grupKisiler.length} Misafir</span>
              </div>
              <span className="text-2xl font-black text-indigo-700 tracking-tight">{grupToplamTutar.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</span>
            </div>

            <div className="grid grid-cols-2 gap-5">
              <div>
                <label className={labelClass}>Para Birimi</label>
                <select className={inputClass} value={grupForm.paraBirimi} onChange={e => setGrupForm(p => ({ ...p, paraBirimi: e.target.value }))}>
                  <option value="TL">TL</option>
                  {(paraBirimleri || []).filter(p => p.tcmbKod !== 'TL' && p.tcmbKod !== 'TRY').map(p => (
                    <option key={p.tcmbKod} value={p.tcmbKod}>{p.tcmbKod}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className={labelClass}>Ödeme Tipi</label>
                <select className={inputClass} value={grupForm.odemeTipi} onChange={e => setGrupForm(p => ({ ...p, odemeTipi: e.target.value }))}>
                  {odemeTipleri.map(o => <option key={o.ad} value={o.ad}>{o.ad}</option>)}
                </select>
              </div>
            </div>

            {!isNakitTipi(grupForm.odemeTipi) && bankalar.length > 0 && (
              <div className="animate-scaleIn origin-top">
                <label className={labelClass}>Banka</label>
                <select className={inputClass} value={grupForm.bankaAdi} onChange={e => setGrupForm(p => ({ ...p, bankaAdi: e.target.value }))}>
                  <option value="">Seçiniz</option>
                  {bankalar.map(b => <option key={b.ad} value={b.ad}>{b.ad}</option>)}
                </select>
              </div>
            )}

            <div>
              <label className={labelClass}>Not</label>
              <input className={inputClass} value={grupForm.notlar} onChange={e => setGrupForm(p => ({ ...p, notlar: e.target.value }))} placeholder="Grup için genel notlar..." />
            </div>

            <label className="flex items-center gap-3 p-4 rounded-xl border border-gray-100 bg-gray-50/50 cursor-pointer group transition-colors hover:bg-gray-50">
              <input type="checkbox" checked={grupForm.odendi} onChange={e => setGrupForm(p => ({ ...p, odendi: e.target.checked }))} className="w-5 h-5 rounded text-indigo-500 focus:ring-indigo-500 border-gray-300 transition-transform group-hover:scale-110" />
              <span className="text-[11px] font-black text-gray-600">Ödeme anında tahsil edildi (Kasaya yansıt)</span>
            </label>

            <button onClick={handleGrupEkle} disabled={grupKaydediliyor}
              className="w-full bg-gradient-to-r from-indigo-500 to-violet-600 hover:opacity-90 text-white rounded-2xl py-4 pt-4.5 text-[11px] font-black uppercase tracking-[0.2em] shadow-[0_10px_20px_-10px_rgba(99,102,241,0.5)] transition-all hover:-translate-y-1 disabled:opacity-50 mt-4">
              {grupKaydediliyor ? 'KAYDEDİLİYOR...' : `👥 ${grupKisiler.length} KİŞİLİK GRUBU KAYDET`}
            </button>
            </div>)}
          </div>
        </div>
        {/* ── Sağ: Liste ── */}
        <div className="lg:col-span-2 bg-white rounded-[2rem] border border-gray-100 shadow-xl overflow-hidden animate-slideInRight h-fit flex flex-col">
          {/* Filtreler */}
          <div className="p-8 border-b border-gray-100 flex flex-wrap items-center gap-4 bg-gray-50/50 backdrop-blur-md relative z-10">
            <div className="w-48 relative">
              <DatePicker value={filtreTarih} onChange={setFiltreTarih} placeholder="Tarih Filtrele" className={inputClass} />
            </div>
            <select className={`${inputClass} !w-auto !py-3`}
              value={filtreTip} onChange={e => setFiltreTip(e.target.value)}>
              <option value="hepsi">Tüm Filtreler</option>
              <option value="yetiskin">Sadece Yetişkin</option>
              <option value="cocuk">Sadece Çocuk</option>
            </select>
            <select className={`${inputClass} !w-auto !py-3`}
              value={filtreOdeme} onChange={e => setFiltreOdeme(e.target.value)}>
              <option value="hepsi">Tüm Tahsilatlar</option>
              <option value="odendi">Ödemesi Alınanlar</option>
              <option value="bekliyor">Ödeme Bekleyenler</option>
            </select>
            {(filtreTarih || filtreTip !== 'hepsi' || filtreOdeme !== 'hepsi') && (
              <button onClick={() => { setFiltreTarih(''); setFiltreTip('hepsi'); setFiltreOdeme('hepsi'); }}
                className="text-[10px] font-black text-rose-500 hover:text-white hover:bg-rose-500 transition-all uppercase tracking-widest px-4 py-3 rounded-xl border border-rose-100 hover:border-rose-500 ml-auto flex items-center gap-2">
                ✕ Temizle
              </button>
            )}
            <div className={`ml-auto flex flex-col items-end ${(filtreTarih || filtreTip !== 'hepsi' || filtreOdeme !== 'hepsi') ? 'hidden md:flex' : ''}`}>
              <span className="text-[9px] font-black text-gray-400 uppercase tracking-[0.2em]">Listelenen Kayıt</span>
              <span className="text-xl font-black text-gray-800 leading-none">{toplamKisi}</span>
            </div>
          </div>

          {yukleniyor ? (
            <LoadingSpinner fullPage color="cyan" size="lg" />
          ) : filtered.length === 0 ? (
            <div className="flex-1 flex flex-col items-center justify-center p-20 min-h-[400px]">
              <div className="w-32 h-32 bg-gray-50 rounded-full flex items-center justify-center text-6xl shadow-inner mb-6 opacity-50 relative">
                 <span className="relative z-10">🏊</span>
                 <div className="absolute inset-0 border-4 border-dashed border-gray-200 rounded-full animate-spin-slow"/>
              </div>
              <h3 className="text-xl font-black text-gray-800 tracking-tight">Kayıt Bulunamadı</h3>
              <p className="text-[11px] font-black text-gray-400 uppercase tracking-widest mt-2 text-center max-w-xs leading-relaxed">
                Belirlediğiniz kriterlere uygun veya bugün için hiç havuz girişi yapılmamış.
              </p>
            </div>
          ) : (
            <div className="overflow-x-auto min-h-[400px] flex-1 custom-scrollbar">
              <table className="w-full text-left">
                <thead className="bg-gray-50/80 backdrop-blur sticky top-0 z-10 border-b border-gray-100 text-[10px] uppercase font-black text-gray-400 tracking-widest">
                  <tr>
                    <th className="px-8 py-5 whitespace-nowrap">Tarih</th>
                    <th className="px-8 py-5">Misafir Bilgisi</th>
                    <th className="px-8 py-5">Tip</th>
                    <th className="px-8 py-5 text-right whitespace-nowrap">Tutar Bilgisi</th>
                    <th className="px-8 py-5 text-center">Ödeme Şekli</th>
                    <th className="px-8 py-5 text-center">Durum</th>
                    <th className="px-8 py-5"></th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {filtered.map((g, i) => {
                    const kalan = g.tutar - (g.odenenTutar || 0);
                    return (
                      <tr key={g.havuzGecisId} className="hover:bg-cyan-50/30 transition-all group duration-300 transform origin-left">
                        <td className="px-8 py-5">
                          <span className="font-semibold text-gray-500 text-xs tracking-tight">{g.girisTarihi}</span>
                        </td>
                        <td className="px-8 py-5">
                          <div className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-xl bg-gray-50 flex items-center justify-center text-lg font-bold text-gray-300 group-hover:bg-cyan-100 group-hover:text-cyan-600 transition-colors shadow-sm border border-gray-100/50">
                               {g.misafirAdi.charAt(0).toUpperCase()}
                            </div>
                            <div>
                                <div className="font-black text-gray-800 text-sm tracking-tight flex items-center gap-2">
                                  {g.misafirAdi}
                                  {g.grupAdi && <span className="text-[9px] bg-gradient-to-r from-indigo-500 to-indigo-600 text-white px-2 py-1 rounded-md uppercase tracking-widest shadow-sm border border-indigo-400 whitespace-nowrap"><span className="text-indigo-200">👥</span> {g.grupAdi}</span>}
                                </div>
                                {g.notlar && <p className="text-gray-400 font-semibold text-[10px] mt-1 line-clamp-1 max-w-[200px] uppercase tracking-wide opacity-70 group-hover:opacity-100 transition-opacity">NOT: {g.notlar}</p>}
                            </div>
                          </div>
                        </td>
                        <td className="px-8 py-5">
                          {g.misafirTipi === 'cocuk'
                            ? <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-xl bg-cyan-50 border border-cyan-100 text-cyan-700 text-[10px] font-black tracking-widest uppercase">👦 Çocuk{g.yas != null ? ` (${g.yas})` : ''}</span>
                            : <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-xl bg-gray-50 border border-gray-200/60 text-gray-600 text-[10px] font-black tracking-widest uppercase">👤 Yetişkin</span>}
                        </td>
                        <td className="px-8 py-5 text-right whitespace-nowrap">
                          {g.tutar === 0
                            ? <span className="text-[11px] font-black text-emerald-500 bg-emerald-50 px-3 py-1.5 rounded-xl border border-emerald-100 uppercase tracking-[0.2em] inline-block shadow-sm">ÜCRETSİZ</span>
                            : (
                                <div className="flex flex-col items-end">
                                   <span className="text-[17px] font-black text-gray-800 tracking-tighter leading-none mb-1">{g.tutar.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</span>
                                   {(g.odenenTutar || 0) > 0 && <span className="text-[10px] font-black text-emerald-500 uppercase tracking-widest border border-emerald-100 bg-emerald-50 px-2 py-0.5 rounded-md">Tahsilat: {(g.odenenTutar).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</span>}
                                </div>
                              )}
                        </td>
                        <td className="px-8 py-5 text-center">
                          <span className="text-[11px] font-black text-gray-500 bg-gray-50 border border-gray-200/60 px-3 py-1.5 rounded-xl uppercase tracking-widest">{g.odemeTipi || 'N/A'}</span>
                        </td>
                        <td className="px-8 py-5 text-center">
                          {g.odendi
                            ? <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-xl bg-emerald-50 border border-emerald-100 text-emerald-600 text-[10px] font-black uppercase tracking-widest shadow-sm"><span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"/> ÖDENDİ</span>
                            : (
                              <div className="flex flex-col items-center">
                                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-xl bg-rose-50 border border-rose-100 text-rose-600 text-[10px] font-black uppercase tracking-widest shadow-sm"><span className="w-1.5 h-1.5 rounded-full bg-rose-500 animate-pulse"/> BEKLİYOR</span>
                                {kalan > 0 && kalan < g.tutar && (
                                  <p className="text-rose-500 text-[9px] font-black mt-1.5 bg-white px-2 py-0.5 rounded-md border border-rose-100 shadow-sm">{kalan.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺ Bakiye</p>
                                )}
                              </div>
                            )}
                        </td>
                        <td className="px-8 py-5">
                          <div className="flex items-center gap-2 justify-end">
                            {!g.odendi && g.grupAdi && grupOzeti[g.grupAdi] && !grupOzeti[g.grupAdi].hepsiBitti && (
                              <button onClick={() => handleGrupOdeAc(g.grupAdi)}
                                className="flex items-center gap-2 text-[10px] bg-indigo-50 hover:bg-indigo-600 hover:text-white text-indigo-600 border border-indigo-100 px-3 py-2 rounded-xl font-black uppercase tracking-widest transition-all shadow-sm">
                                💳 Grup Tahsilat
                              </button>
                            )}
                            {!g.odendi && !g.grupAdi && (
                              <button onClick={() => handleOdeAc(g)}
                                className="flex items-center gap-2 text-[10px] bg-emerald-50 hover:bg-emerald-600 hover:text-white text-emerald-600 border border-emerald-100 px-3 py-2 rounded-xl font-black uppercase tracking-widest transition-all shadow-sm">
                                💰 Tahsilat
                              </button>
                            )}
                            <button onClick={() => handleSil(g.havuzGecisId, g.misafirAdi)}
                              className="text-gray-300 hover:text-rose-500 text-lg transition-colors p-2 hover:bg-rose-50 rounded-xl" title="Kaydı Sil">
                              <IkonSil />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>

      {/* ── Ödeme Modalı ── */}
      {odeModal && (
        <div className="fixed inset-0 bg-gray-900/40 backdrop-blur-sm z-[200] flex items-end sm:items-center justify-center sm:p-4 animate-fadeIn" onClick={() => setOdeModal(null)}>
          <div className="bg-white rounded-t-[2.5rem] sm:rounded-[2.5rem] p-8 w-full sm:max-w-md shadow-2xl relative overflow-hidden animate-scaleIn origin-bottom sm:origin-center" onClick={e => e.stopPropagation()}>
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-emerald-400 to-teal-500" />
            
            <div className="flex justify-center -mt-4 mb-6 sm:hidden">
              <div className="w-12 h-1.5 bg-gray-200 rounded-full"/>
            </div>

            <div className="flex items-center justify-between mb-8">
              <h3 className="font-black text-2xl text-gray-800 flex items-center gap-3 tracking-tight">
                <span className="w-12 h-12 bg-emerald-50 text-emerald-500 rounded-2xl flex items-center justify-center shadow-inner border border-emerald-100 text-xl"><IkonOde /></span>
                Tahsilat Al
              </h3>
              <button onClick={() => setOdeModal(null)} className="text-gray-400 hover:text-gray-600 bg-gray-50 hover:bg-gray-100 w-10 h-10 rounded-full flex items-center justify-center transition-colors">✕</button>
            </div>

            <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-2xl p-5 mb-8 border border-emerald-100/50 shadow-inner">
              <div className="flex items-center justify-between mb-3 pb-3 border-b border-emerald-100/50">
                   <div className="flex flex-col">
                       <span className="text-[10px] font-black text-emerald-600/70 uppercase tracking-widest">MİSAFİR</span>
                       <span className="font-bold text-emerald-900">{odeModal.misafirAdi}</span>
                   </div>
                   <div className="flex flex-col items-end">
                       <span className="text-[10px] font-black text-emerald-600/70 uppercase tracking-widest">TOPLAM</span>
                       <span className="font-bold text-emerald-900">{odeModal.tutar?.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</span>
                   </div>
              </div>
              <div className="flex items-center justify-between">
                  <div className="flex flex-col">
                      <span className="text-[10px] font-black text-emerald-600/70 uppercase tracking-widest">ÖDENEN</span>
                      <span className="font-bold text-emerald-600">{odeModal.odenenTutar > 0 ? (odeModal.odenenTutar).toLocaleString('tr-TR', { minimumFractionDigits: 2 }) + ' ₺' : '0,00 ₺'}</span>
                  </div>
                  <div className="flex flex-col items-end">
                      <span className="text-[10px] font-black text-rose-500 uppercase tracking-widest">KALAN BAKİYE</span>
                      <span className="font-black text-xl text-rose-600">{(odeModal.tutar - odeModal.odenenTutar).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</span>
                  </div>
              </div>
            </div>

            <div className="space-y-5">
                <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className={labelClass}>Ödeme Tipi *</label>
                      <select className={inputClass} value={odeForm.odemeTipi} onChange={e => setOdeForm(p => ({ ...p, odemeTipi: e.target.value }))}>
                        {odemeTipleri.map(o => <option key={o.ad} value={o.ad}>{o.ad}</option>)}
                      </select>
                    </div>
                    <div>
                      <label className={labelClass}>Para Birimi</label>
                      <select className={inputClass} value={odeForm.paraBirimi} onChange={e => setOdeForm(p => ({ ...p, paraBirimi: e.target.value }))}>
                        <option value="TL">TL</option>
                        {(paraBirimleri || []).filter(p => p.tcmbKod !== 'TL' && p.tcmbKod !== 'TRY').map(p => (
                          <option key={p.tcmbKod} value={p.tcmbKod}>{p.tcmbKod}</option>
                        ))}
                      </select>
                    </div>
                </div>

                {!isNakitTipi(odeForm.odemeTipi) && bankalar.length > 0 && (
                  <div className="animate-scaleIn origin-top">
                    <label className={labelClass}>Banka</label>
                    <select className={inputClass} value={odeForm.bankaAdi} onChange={e => setOdeForm(p => ({ ...p, bankaAdi: e.target.value }))}>
                      <option value="">Seçiniz</option>
                      {bankalar.map(b => <option key={b.ad} value={b.ad}>{b.ad}</option>)}
                    </select>
                  </div>
                )}

                <div>
                  <label className={labelClass}>Tahsil Edilecek Tutar ({odeForm.paraBirimi})</label>
                  <div className="relative">
                      <input type="number" min="0" step="0.01" className={`${inputClass} text-lg py-4 border-emerald-100 focus:border-emerald-500 focus:ring-emerald-50`}
                        value={odeForm.tutar}
                        onChange={e => setOdeForm(p => ({ ...p, tutar: e.target.value }))} />
                      <span className="absolute right-4 top-1/2 -translate-y-1/2 text-[10px] font-black text-gray-400">{odeForm.paraBirimi}</span>
                  </div>
                  {tlKarsiligi(odeForm.tutar, odeForm.paraBirimi) !== null && (
                    <p className="text-[10px] font-black text-emerald-600 bg-emerald-50 px-3 py-2 rounded-xl mt-2 inline-flex items-center gap-1.5 uppercase tracking-widest animate-fadeIn">
                       KARŞILIĞI: {tlKarsiligi(odeForm.tutar, odeForm.paraBirimi).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                    </p>
                  )}
                </div>

                <div className="flex gap-4 pt-4">
                  <button onClick={() => setOdeModal(null)} className="flex-1 border-2 border-gray-100 rounded-2xl py-4 text-[11px] font-black text-gray-500 hover:bg-gray-50 transition uppercase tracking-widest">İptal</button>
                  <button onClick={handleOde} disabled={odeYukleniyor}
                    className="flex-1 bg-gradient-to-r from-emerald-500 to-teal-500 hover:opacity-90 text-white rounded-2xl py-4 text-[11px] font-black uppercase tracking-[0.2em] disabled:opacity-50 transition shadow-xl hover:-translate-y-1">
                    {odeYukleniyor ? 'İşleniyor...' : '💰 TAHSİL ET'}
                  </button>
                </div>
            </div>
          </div>
        </div>
      )}

      {/* ── Grup Ödeme Modalı ── */}
      {grupOdeModal && (
        <div className="fixed inset-0 bg-gray-900/40 backdrop-blur-sm z-[200] flex items-end sm:items-center justify-center sm:p-4 animate-fadeIn" onClick={() => setGrupOdeModal(null)}>
          <div className="bg-white rounded-t-[2.5rem] sm:rounded-[2.5rem] p-8 w-full sm:max-w-md shadow-2xl relative overflow-hidden animate-scaleIn origin-bottom sm:origin-center" onClick={e => e.stopPropagation()}>
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-violet-500 to-indigo-600" />
            
            <div className="flex justify-center -mt-4 mb-6 sm:hidden">
              <div className="w-12 h-1.5 bg-gray-200 rounded-full"/>
            </div>

            <div className="flex items-center justify-between mb-8">
              <h3 className="font-black text-2xl text-gray-800 flex items-center gap-3 tracking-tight">
                <span className="w-12 h-12 bg-violet-50 text-violet-600 rounded-2xl flex items-center justify-center shadow-inner border border-violet-100 text-xl">👥</span>
                Grup Tahsilatı
              </h3>
              <button onClick={() => setGrupOdeModal(null)} className="text-gray-400 hover:text-gray-600 bg-gray-50 hover:bg-gray-100 w-10 h-10 rounded-full flex items-center justify-center transition-colors">✕</button>
            </div>

            <div className="bg-gradient-to-br from-violet-50 to-indigo-50 rounded-2xl p-5 mb-8 border border-violet-100/50 shadow-inner">
              <div className="flex items-center justify-between mb-3 pb-3 border-b border-violet-100/50">
                   <div className="flex flex-col">
                       <span className="text-[10px] font-black text-violet-600/70 uppercase tracking-widest">GRUP BİLGİSİ</span>
                       <span className="font-bold text-violet-900">{grupOdeModal.grupAdi}</span>
                   </div>
                   <div className="flex flex-col items-end">
                       <span className="text-[10px] font-black text-violet-600/70 uppercase tracking-widest">TOPLAM</span>
                       <span className="font-bold text-violet-900">{grupOdeModal.toplamTutar?.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</span>
                   </div>
              </div>
              <div className="flex items-center justify-between">
                  <div className="flex flex-col">
                      <span className="text-[10px] font-black text-violet-600/70 uppercase tracking-widest">ÖDENEN</span>
                      <span className="font-bold text-violet-600">{grupOdeModal.odenenTutar > 0 ? (grupOdeModal.odenenTutar).toLocaleString('tr-TR', { minimumFractionDigits: 2 }) + ' ₺' : '0,00 ₺'}</span>
                  </div>
                  <div className="flex flex-col items-end">
                      <span className="text-[10px] font-black text-rose-500 uppercase tracking-widest">KALAN BAKİYE</span>
                      <span className="font-black text-xl text-rose-600">{(grupOdeModal.toplamTutar - grupOdeModal.odenenTutar).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</span>
                  </div>
              </div>
            </div>

            <div className="space-y-5">
                <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className={labelClass}>Ödeme Tipi *</label>
                      <select className={inputClass} value={grupOdeForm.odemeTipi} onChange={e => setGrupOdeForm(p => ({ ...p, odemeTipi: e.target.value }))}>
                        {odemeTipleri.map(o => <option key={o.ad} value={o.ad}>{o.ad}</option>)}
                      </select>
                    </div>
                    <div>
                      <label className={labelClass}>Para Birimi</label>
                      <select className={inputClass} value={grupOdeForm.paraBirimi} onChange={e => setGrupOdeForm(p => ({ ...p, paraBirimi: e.target.value }))}>
                        <option value="TL">TL</option>
                        {(paraBirimleri || []).filter(p => p.tcmbKod !== 'TL' && p.tcmbKod !== 'TRY').map(p => (
                          <option key={p.tcmbKod} value={p.tcmbKod}>{p.tcmbKod}</option>
                        ))}
                      </select>
                    </div>
                </div>

                {!isNakitTipi(grupOdeForm.odemeTipi) && bankalar.length > 0 && (
                  <div className="animate-scaleIn origin-top">
                    <label className={labelClass}>Banka</label>
                    <select className={inputClass} value={grupOdeForm.bankaAdi} onChange={e => setGrupOdeForm(p => ({ ...p, bankaAdi: e.target.value }))}>
                      <option value="">Seçiniz</option>
                      {bankalar.map(b => <option key={b.ad} value={b.ad}>{b.ad}</option>)}
                    </select>
                  </div>
                )}

                <div>
                  <label className={labelClass}>Tahsil Edilecek Tutar ({grupOdeForm.paraBirimi})</label>
                  <div className="relative">
                      <input type="number" min="0" step="0.01" className={`${inputClass} text-lg py-4 border-violet-100 focus:border-violet-500 focus:ring-violet-50`}
                        value={grupOdeForm.tutar}
                        onChange={e => setGrupOdeForm(p => ({ ...p, tutar: e.target.value }))} />
                      <span className="absolute right-4 top-1/2 -translate-y-1/2 text-[10px] font-black text-gray-400">{grupOdeForm.paraBirimi}</span>
                  </div>
                  {tlKarsiligi(grupOdeForm.tutar, grupOdeForm.paraBirimi) !== null && (
                    <p className="text-[10px] font-black text-violet-600 bg-violet-50 px-3 py-2 rounded-xl mt-2 inline-flex items-center gap-1.5 uppercase tracking-widest animate-fadeIn">
                       KARŞILIĞI: {tlKarsiligi(grupOdeForm.tutar, grupOdeForm.paraBirimi).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                    </p>
                  )}
                </div>

                <div className="flex gap-4 pt-4">
                  <button onClick={() => setGrupOdeModal(null)} className="flex-1 border-2 border-gray-100 rounded-2xl py-4 text-[11px] font-black text-gray-500 hover:bg-gray-50 transition uppercase tracking-widest">İptal</button>
                  <button onClick={handleGrupOde} disabled={grupOdeYukleniyor}
                    className="flex-1 bg-gradient-to-r from-violet-500 to-indigo-600 hover:opacity-90 text-white rounded-2xl py-4 text-[11px] font-black uppercase tracking-[0.2em] disabled:opacity-50 transition shadow-xl hover:-translate-y-1">
                    {grupOdeYukleniyor ? 'İşleniyor...' : '💳 TAHSİL ET'}
                  </button>
                </div>
            </div>
          </div>
        </div>
      )}
      {/* ── Alt Bilgi ── */}
      <UsageInfo
        id="havuz-yonetimi"
        color="violet"
        title="Nasıl Kullanılır?"
        description="Havuz yönetim sayfasında günübirlik havuz girişi yapan misafirlerin kayıtlarını tutabilir, tahsilatlarını gerçekleştirebilir ve anlık havuz doluluk oranını takip edebilirsiniz."
        scenarios={[
          { title: "Hızlı Giriş Kaydı", content: "Sol taraftaki form üzerinden misafir adı ve kişi sayısını girerek anında yeni bir havuz fişi oluşturabilirsiniz." },
          { title: "Grup Girişi", content: "Grup Girişi sekmesi ile kalabalık misafir gruplarını tek seferde sisteme işleyebilir ve toplu ödemelerini anında alabilirsiniz." },
          { title: "Dövizli Ödemeler", content: "Tahsilat sırasında istediğiniz para birimini seçebilir, sistemin otomatik kur çevirisi sayesinde TL karşılığını görebilirsiniz." }
        ]}
      />
    </div>
  );
}
